import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-students-list-dialog',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './students-list-dialog.component.html',
  styleUrl: './students-list-dialog.component.scss',
})
export class StudentsListDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
}
